'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".TextLink-module_textLink__cMa5a{border:0;color:#2b7cac;font-size:.875rem;line-height:1.25rem;padding:0}.TextLink-module_textLink__cMa5a,.TextLink-module_textLink__cMa5a:hover{background:transparent;-webkit-text-decoration:underline;text-decoration:underline}.TextLink-module_textLink__cMa5a:hover{color:\"inherit\";cursor:pointer}";
var styles = {"textLink":"TextLink-module_textLink__cMa5a"};
styleInject["default"](css_248z, '709b8782-31fd-48cb-aaa1-d0d3703f22da');

exports["default"] = styles;
